import React from "react";
import Image from "next/image";
import Link from "next/link";
import quickLinksData from "../../content/home/quicklinks.json";

export default function QuickLinksSection() {
  return (
    <section className="py-12 px-4 md:px-10">
      <h2 className="text-3xl font-bold text-center mb-10">Explore Our Collections</h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 max-w-6xl mx-auto">
        {quickLinksData.map((item, index) => (
          <Link href={item.href} key={index}>
            <div className="relative h-48 rounded-xl overflow-hidden shadow-md cursor-pointer group">
              <Image
                src={item.image}
                alt={item.label}
                fill
                className="object-cover group-hover:scale-105 transition-transform duration-300"
              />
              <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center text-white text-xl font-semibold">
                {item.label}
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}